(function ($) {
  jQuery(document).ready(function(){
    var signed_in_value = site.userInfoCookie.getValue('signed_in');
      if (signed_in_value == 1) {
        $('.site-utils__item--account .site-utils__link-text').text(rb.language.member_information);
      }
  });
})(jQuery);
